import Nav from "../Nav";
import '../styles/cart.scss';
import { TextField, Alert, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useState } from "react"
import axios from "axios";

export default function MonthlyForm() {
  const [mailSent, setMailSent] = useState(false);
  const [tcs, setTcs] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [product, setProduct] = useState('');
  // Alert
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [showAlert, setShowAlert] = useState(false);

  // const url = 'http://localhost:3999';
  const url = 'https://dev.pmwwebdesign.com';


  const handleTc = (value) => {
    setTcs(value);
  };

  const handleContact = () => {
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
    const phoneRegex = /^[0-9]*$/

    if (firstName === "" || lastName === "" || phone === "" || email === "" || product === "") {
      setMessage('All fields are required')
      setSeverity('warning')
      setShowAlert(true)
      setTimeout(() => {
        setShowAlert(false)
      }, 2000)
    } else if (!email.match(regex)) {
      setMessage('Email is the wrong format')
      setSeverity('warning')
      setShowAlert(true)
      setTimeout(() => {
        setShowAlert(false)
      }, 2000)
    } else if (!phone.match(phoneRegex)) {
      setMessage('Please insert your phone with only numbers')
      setSeverity('warning')
      setShowAlert(true)
      setTimeout(() => {
        setShowAlert(false)
      }, 2000)
    } else if (!tcs) {
      setMessage('You need to accept the T&C')
      setSeverity('warning')
      setShowAlert(true)
      setTimeout(() => {
        setShowAlert(false)
      }, 2000)
    } else {
      // TODO: move to payment sent Data to mogo and save on localStorage
      let data = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
        product: product,
      }
      axios.post(`${url}/property/ft-plan`, data)
        .then((res) => {
          setMailSent(true)
        }).catch((err) => {
          console.log(err)
          setMessage('something went wrong, please try again')
          setSeverity('error')
          setShowAlert(true)
          setTimeout(() => {
            setShowAlert(false)
          }, 2000)
        })
    }
  }

  return (
    <main className="cart" style={{ backgroundColor: '#E6EDF7' }}>
      {!mailSent ? (
        <section className="form">
          <h2>If You Wish To Discuss A Payment Plan, <br/>Get In Touch Now</h2>
          <section className="form__row">
            <FormControl className="select">
              <InputLabel id="demo-simple-select-label">Please Select Product to Discuss</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={product}
                label="Age"
                onChange={(e) => setProduct(e.target.value)}
              >
                <MenuItem value='Property Fast Track Bundle'>Property Fast Track Bundle & Land Development</MenuItem>
                <MenuItem value='Property Fast Track Product'>Property Fast Track Bundle</MenuItem>
                <MenuItem value='Land Development'>Land Development Course</MenuItem>
              </Select>
            </FormControl>
          </section>
          <section className="form__row">
            <TextField id="outlined-basic" label="First Name" variant="outlined" className='field' onChange={(e) => setFirstName(e.target.value)} required />
            <TextField id="outlined-basic" label="Last Name" variant="outlined" className='field' onChange={(e) => setLastName(e.target.value)} required />
          </section>
          <section className="form__row">
            <TextField id="outlined-basic" label="Email" variant="outlined" className='field' onChange={(e) => setEmail(e.target.value)} required />
            <TextField id="outlined-basic" label="Phone Number" variant="outlined" className='field' onChange={(e) => setPhone(e.target.value)} pattern='[0-9]*' required />
          </section>
          <FormControlLabel
            control={<Checkbox />}
            label="I confirm I have read and agree to the terms & conditions"
            onChange={(e) => handleTc(e.target.checked)}
          />

          {showAlert ? (
            <Alert severity={severity} width="80%" sx={{ margin: '3% auto' }}>{message}</Alert>
          ) : (
            <button onClick={handleContact}>Get In Touch</button>
          )}

        </section>
      ) : (
        <section className="form">
          <h2>Thank You, a member of the team will get in touch soon</h2>
        </section>
      )}
    </main>
  )
}